export default __webpack_public_path__ + "static/media/credenciadoMobile.c983cbc8.gif";